export default "__VITE_ASSET__HGIo2cRn__"